import { apiClient } from "../../../api/httpClient";

/** Convert ISO timestamp for `<input type="datetime-local" />`. */
export function isoToDatetimeLocal(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** Upload retrieval bond file → ADLS blob link (same as legacy `uploadToADLS`). */
export async function uploadBondFileToADLS(file) {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("file_name", file.name);
    const response = await apiClient("/bond-file-upload/", "POST", formData, {}, {
      "Content-Type": "multipart/form-data",
    });
    if (!response.blob_link) {
      throw new Error("Blob link not returned from the server.");
    }
    return response.blob_link;
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
}

/** Alias for components that historically imported `uploadToADLS`. */
export const uploadToADLS = uploadBondFileToADLS;
